import { useState } from "react";
import { useCandidateStore, CandidateStatus } from "../../store/useCandidateStore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AdminCandidateCard({ candidate, onViewDetail, vacancyId }: any) {
  const data = candidate.candidate;
  const vacancy_id = candidate.vacancy_id;
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<CandidateStatus>("applied");

  const { updateCandidateStatus, fetchSidebarInfo, fetchCandidatesByStatus } = useCandidateStore();

  const applicationId = candidate.id;

  const handleSaveStatus = async () => {
    try {
      await updateCandidateStatus(applicationId, vacancyId, selectedStatus);
      toast.success("Status updated successfully!");

      // Refresh sidebar & candidates
      await fetchSidebarInfo(vacancy_id);
      await fetchCandidatesByStatus(vacancy_id, selectedStatus);

      setShowStatusModal(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update status.");
    }
  };

  return (
    <div className="border rounded-xl bg-white p-4 shadow-sm text-center">
      <img
        src={data.photo || "https://placehold.co/120x120"}
        alt={data.name}
        className="w-28 h-28 rounded-full object-cover mx-auto border"
      />

      <h3 className="text-lg font-semibold mt-3">{data.name}</h3>
      <p className="text-gray-600 text-sm mt-1">{data.email || "-"}</p>

      <div className="flex gap-2 mt-4">
        <button
          onClick={onViewDetail}
          className="bg-primary text-white w-full py-2 rounded-lg font-medium"
        >
          View Detail
        </button>

        <button
          onClick={() => setShowStatusModal(true)}
          className="bg-secondary text-black w-full py-2 rounded-lg font-medium"
        >
          Update Status
        </button>
      </div>

      {showStatusModal && (
        <div
          className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 p-4"
          onClick={() => setShowStatusModal(false)}
        >
          <div
            className="bg-white rounded-xl w-full max-w-md p-6 shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-semibold mb-4">Update Status</h2>

            <div className="flex flex-col gap-3 mb-4">
              {["reviewed", "interviewed", "hired", "rejected"].map((status) => (
                <label key={status} className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="status"
                    value={status}
                    checked={selectedStatus === status}
                    onChange={() => setSelectedStatus(status as CandidateStatus)}
                  />
                  {status.charAt(0).toUpperCase() + status.slice(1)}
                </label>
              ))}
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowStatusModal(false)}
                className="px-4 py-2 rounded-lg border"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveStatus}
                className="px-4 py-2 rounded-lg bg-primary text-white"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
